import axiosInstance from '../fetchConfig/axiosConfig';
import logger from '../utils/logger';

/**
 * Send assignment notification email via backend template.
 * @param {Object} assignmentData
 * @returns {Promise<Object>}
 */
export const sendAssignmentNotification = async (assignmentData) => {
  try {
    const {
      assigneeId,
      cases,
      parcelIds,
      addresses,
      reviewType,
      taxYear,
      muniCode,
      assignerId,
      dueDate,
      flagType,
      miscDesc,
    } = assignmentData;

    const appOrigin = typeof window !== 'undefined' ? window.location.origin : 'https://proprietyrealty.com';

    const emailResponse = await axiosInstance.post('/send_assignment_notification', {
      assigneeId,
      assignerId,
      cases,
      parcelIds,
      addresses,
      reviewType,
      taxYear,
      muniCode,
      dueDate,
      flagType,
      miscDesc,
      appOrigin,
    });

    if (emailResponse.status === 200 && emailResponse.data?.success) {
      return { success: true, message: emailResponse.data.message || 'Assignment notification email sent successfully' };
    }
    return {
      success: false,
      error: emailResponse.data?.error || 'Failed to send assignment notification email',
    };
  } catch (error) {
    return { success: false, error: error.message || 'Failed to send assignment notification' };
  }
};
